import gql from 'graphql-tag';

export const UPDATE_USER = gql`
  mutation(
    $policyId: String
    $firstName: String
    $middleName: String
    $lastName: String
    $title: String
    $gender: Gender
    $phoneNumber: String
    $email: String
    $address: String
    $description: String
    $avatar: String
    $dateOfBirth: String
  ) {
    updateUser(
      input: {
        policyId: $policyId
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        title: $title
        description: $description
        gender: $gender
        phoneNumber: $phoneNumber
        email: $email
        address: $address
        avatar: $avatar
        dateOfBirth: $dateOfBirth
      }
    ) {
      userId
      type
      profile {
        avatar
        title
        gender
        firstName
        middleName
        lastName
        email
        phoneNumber
        address
        description
        dateOfBirth
        policyId
        externalId
        timezone
      }
    }
  }
`;
